import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-youtube-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-youtube-block-editor.html',
})
export class LandingPageYouTubeBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  updateYouTubeUrl(value: string): void {
    this.blockChange.emit({ youTubeUrl: value });
  }
}
